import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import MilestoneIssueActivity from "./MilestoneIssueActivity";
import MilestoneIssueDocument from "./MilestoneIssueDocument";
import MilestoneIssueComments from "./MilestoneIssueComments";
import MilestoneIssueLogHours from "./MilestoneIssueLogHour";
import MilestoneIssuetask from "./MilestoneIssueTask";
import { editProjectDetails, fetchEntityById } from "../../../../apis/apiService";
import {
  useFetchGetAllProjectBasedUserNameListQuery,
  useFetchMilestoneIsssueViewQuery,
  useFetchMilestoneModuleQuery,
  useFetchGetallMilestoneIssueCommentsQuery,
} from "../../../../slice/logdetailSlice";
import { CommonIssueDetail } from "../../../common/Issue/CommonIssueDetail";


export const MilestoneIssueTabs = ({
  MilestoneissueDetail,
  document_count,
  comment_count,
  assignee_name,
  added_by,
  login_user_name,
  login_user_id,
  issue_id,
  login_user_role,
  logHours,
}) => {
  const { data: issueCommentsData } = useFetchGetallMilestoneIssueCommentsQuery(issue_id);

  const milestoneIssueComments = Array.isArray(issueCommentsData)
    ? issueCommentsData.filter(
        (comment) =>
          comment.issue_id === Number(issue_id) ||
          comment.comment_type === "ISSUE"
      )
    : [];

  const displayCommentCount = milestoneIssueComments.length;

  const login_users = useSelector(
    (state) => state.selectOptions?.loginUserName
  );
  // const { id: login_user_id, name: login_user_name } = login_users;
  return (
    <div className="mt-3 ">
      <ul className="nav nav-tabs" id="myTab" role="tablist">
        <li className="nav-item pe-4" role="presentation">
          <button
            className=" active text-rgba-gray R_btn"
            id="Comments-tab"
            data-bs-toggle="tab"
            data-bs-target="#Comments"
            type="button"
            role="tab"
            aria-controls="Comments"
            aria-selected="true"
          >
            Comments ({displayCommentCount})
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="Subtasks-tab"
            data-bs-toggle="tab"
            data-bs-target="#Subtasks"
            type="button"
            role="tab"
            aria-controls="Subtasks"
            aria-selected="false"
          >
            Tasks
          </button>
        </li>

        <li className="nav-item pe-4" role="presentation">
          {(["ADMIN", "MANAGER"].includes(login_user_role) || // ✅ Allow Admin & Manager
            login_user_name === assignee_name ||
            login_user_id === added_by) && (
            <button
              className=" text-rgba-gray R_btn"
              id="LogHours-tab"
              data-bs-toggle="tab"
              data-bs-target="#LogHours"
              type="button"
              role="tab"
              aria-controls="LogHours"
              aria-selected="false"
            >
              {/* Log Hours */}
              Log Hours ({logHours || "00:00"})
            </button>
          )}
        </li>

        <li className="nav-item pe-4" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="Documents-tab"
            data-bs-toggle="tab"
            data-bs-target="#Documents"
            type="button"
            role="tab"
            aria-controls="Documents"
            aria-selected="false"
          >
            Documents ({document_count})
          </button>
        </li>

        {/* <li className='nav-item pe-4' role='presentation'>
          <button
            className=' text-rgba-gray R_btn'
            id='StatusTimeline-tab'
            data-bs-toggle='tab'
            data-bs-target='#StatusTimeline'
            type='button'
            role='tab'
            aria-controls='StatusTimeline'
            aria-selected='false'
          >
           Status Timeline
          </button>
        </li> */}

        <li className="nav-item pe-4" role="presentation">
          <button
            className=" text-rgba-gray R_btn"
            id="ActivityStream-tab"
            data-bs-toggle="tab"
            data-bs-target="#ActivityStream"
            type="button"
            role="tab"
            aria-controls="ActivityStream"
            aria-selected="false"
          >
            Activity Stream
          </button>
        </li>
      </ul>

      <div className="tab-content" id="myTabContent">
        <div
          className="tab-pane fade show active"
          id="Comments"
          role="tabpanel"
          aria-labelledby="Comments-tab"
        >
          <MilestoneIssueComments issue_id={issue_id} />
        </div>

        <div
          className="tab-pane fade"
          id="Subtasks"
          role="tabpanel"
          aria-labelledby="Subtasks-tab"
        >
          <MilestoneIssuetask />
        </div>

        <div
          className="tab-pane fade"
          id="LogHours"
          role="tabpanel"
          aria-labelledby="LogHours-tab"
        >
          <MilestoneIssueLogHours />
        </div>

        <div
          className="tab-pane fade"
          id="Documents"
          role="tabpanel"
          aria-labelledby="Documents-tab"
        >
          <MilestoneIssueDocument issue_id={issue_id} />
        </div>

        {/* <div
          className='tab-pane fade'
          id='StatusTimeline'
          role='tabpanel'
          aria-labelledby='StatusTimeline-tab'
        >
        <MilestoneIssueTimeline/>
        </div> */}

        <div
          className="tab-pane fade"
          id="ActivityStream"
          role="tabpanel"
          aria-labelledby="ActivityStream-tab"
        >
          <MilestoneIssueActivity issue_id={issue_id} />
        </div>
      </div>
    </div>
  );
};

const MilestoneIssueDetail = () => {
  const { id } = useParams();
  const { project_id: projectId } = useParams();
  //console.log("project_id_in_milestone :", projectId, id);
  const { milestone_id: milestoneId } = useParams();
  // const projectId = localStorage.getItem("project_id");
  // const milestoneId = localStorage.getItem("milestoneId");
  //console.log("Milestone_idd :", milestoneId);
  const [headanchorEl, setheadAnchorEl] = useState(null);
  const [IssueDetail, setissueDetail] = useState([]);
  const [issuelist, setIssuelist] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [loadding, setLoading] = useState(false);
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  //console.log("login_user in task:", login_user);
  const { role: login_user_role } = login_user;
  //console.log("login_user role in task:", login_user_role);
  const { refetch: milestone_module_refetch, } = useFetchMilestoneModuleQuery();
  const [nameChange, setNameChange] = useState({
    description: "",
    assignee_id: "",
    current_status_id: null,
    due_date: null,
    priority_id: null,
    severity_id: null,
    module: "",
  });

  const { data: project_based_users } =
    useFetchGetAllProjectBasedUserNameListQuery(projectId);
  const { data: issue_detail, refetch, } = useFetchMilestoneIsssueViewQuery(id);
  // Status option from redux
  const StatusOptions = useSelector((state) => state.selectOptions?.StatusOptions);
  const statusNames = StatusOptions.find((status) => status.status_type === "ISSUE");
  const status_list = statusNames?.status_details?.map((status) => ({
    status_id: status.status_id,
    status_name: status.status_name,
    status_colour: status.status_colour,
  }));
  const priorityList = useSelector((state) => state.selectOptions?.PriorityNameOptions);
  const priorityOptions = priorityList.find(
    (list) => list.priority_type === "ISSUE"
  );
  //console.log("priorityOptions : ", priorityOptions);

  const reporterOptions = useSelector(
    (state) => state.selectOptions?.userNamesByProjects
  );
  //console.log("reporterOptions", reporterOptions);

  const serverityOptions = useSelector(
    (state) => state.selectOptions.SeverityNameOptions
  );
  //console.log("serverityOptions", serverityOptions);
  const navigate = useNavigate();
  const { watch, } = useForm({ defaultValues: {},});
  const formValues = watch();
  const previousValues = useRef(formValues);

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleClick = (event) => {
    setheadAnchorEl(event.currentTarget);
  };
  const HeadhandleClose = () => {
    setheadAnchorEl(null);
  };
  // Fetch detail Api call
  useEffect(() => {
    if (issue_detail) {
      setissueDetail(issue_detail);
    }
  }, [issue_detail]);

  const onSubmit = (data) => {
    // //console.log(data);
  };
  // Fetch All issues Api call
  const fetchIssuelist = async () => {
    try {
      const response = await fetchEntityById( "milestones/issue/show", milestoneId );
      setIssuelist(response?.issues);
      //console.log(issuelist, "Issuelist");
    } 
    catch (err) {
      // Show error in toast
      toast.error(err.message || "Failed to fetch subtasks");
    }
  };

  useEffect(() => {
    fetchIssuelist();
  }, [milestoneId]);
  // detail page edit api call

  // Comparsation of field change
  useEffect(() => {
    if (login_user_role !== "CLIENT") {
      // Restrict API update for clients
      const hasChanges = Object.keys(formValues).some(
        (key) => formValues[key] !== previousValues.current[key]
      );

      if (hasChanges) {
        previousValues.current = formValues;
      }
    }
  }, [formValues]);

  useEffect(() => {
    if (IssueDetail) {
      setNameChange({
        description: IssueDetail?.description || "",
        assignee_id: IssueDetail?.assignee_id || "",
        current_status_id: IssueDetail?.current_status_id || "",
        due_date: IssueDetail?.due_date || null,
        priority_id: IssueDetail?.priority_id || "",
        severity_id: IssueDetail?.severity_id || "",
        module: IssueDetail?.module || "",
      });
    }
  }, [IssueDetail]);
  const handleNameChange = (e) => {
    const { name, value } = e.target;
    setNameChange((prev) => ({ ...prev, [name]: value }));
  };
  const handleBlur = async (e) => {
    //console.log("changed_value event: ", e);
    setLoading(true);
    const { name, value } = e.target;
    //console.log("changed_value _blur :", name, value);
    const requestedData = {
      [name]: value,
    };
    try {
      const response = await editProjectDetails( "milestones/issue/update", IssueDetail?.issue_id, requestedData );
      //console.log("API call successful:", response);
      toast.success(response.message);
      milestone_module_refetch();
      refetch();
      // if (response?.status) {
      //   // Assuming response contains status and issues as per the API doc
      //   setissueDetail(response.issues);  // Set the issue details based on the response structure
      // }
    } 
    catch (error) {
      console.error("Error during API call:", error);
      toast.error(error.message || "Failed to update issue details");
    } 
    finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (IssueDetail) {
  //     //console.log("assignee :", IssueDetail.assignee);

  //     const DueDate = dayjs(IssueDetail.due_date);
  //     // Manually set form values based on projectDetail
  //     setValue("description", IssueDetail.description);
  //     setValue("Assignee", IssueDetail.assignee_name);
  //     setValue("current_status_id", IssueDetail.current_status_id);
  //     setValue("due_date", DueDate);
  //     setValue("priority_id", IssueDetail.priority_id);
  //     setValue("severity_id", IssueDetail.severity_id);
  //     setValue("module", IssueDetail.module);
  //   }
  // }, [IssueDetail, setValue]);
  //  Handel list show onclick
  const sliderRef = useRef(null);
  const handleBoxClick = (issue_id) => {
    navigate(`/projects/projectDetail/${projectId}/milestone/MilestoneDetail/${milestoneId}/MilestoneIssueDetail/${issue_id}`);
  };
  // Slider setting
  const settings = {
    dots: false, // Disable dots
    infinite: issuelist.length > 1,
    slidesToShow: issuelist.length === 1 ? 1 : 4,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    swipeToSlide: true,
    beforeChange: function (currentSlide, nextSlide) {
      //console.log("Before change", currentSlide, nextSlide);
    },
    afterChange: function (currentSlide) {
      //console.log("After change", currentSlide);
    },
  };

  const handlePrevClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  const handleNextClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };
  
  useEffect(() => {
    if (!issuelist) return;

    // Find the first matching task and update the state once
    const matchedTask = issuelist.find(
      (list) => list.added_by === issue_detail?.added_by
    );

    if (matchedTask) {
      setSelectedUser(matchedTask.added_by);
    }
  }, [issuelist, issue_detail]);

  //console.log("issue_detail name :", issue_detail);
  //console.log("ouser_s id :", selectedUser, login_user_id);

  return (
    <>
      <CommonIssueDetail
        showpath="milestones/issue/show"
        updatePath="milestones/issue/update"
        project_id={milestoneId}
        id={id}
        project_based_users={project_based_users}
        issue_detail_refetch={refetch}
        issue_module_refetch={milestone_module_refetch}
        handleBoxClick={handleBoxClick}
        isMilestoneIssueDetail={true}
      />
    </>
  );
};

export default MilestoneIssueDetail;
